import React from 'react';
import Lightbox from 'react-image-lightbox';
import {Image} from './image'
import {Grid} from '../Grid'
import {Title} from '../Title'
import { withPrefix } from 'gatsby-link'

const style = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'black',
      zIndex: 20000,
    },
  };

const nImagesPerRowDesktop = 3;
const nImagesPerRowMobile = 2;

class ImageGallery extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      imageIndex: 0,
      isOpen: false,
    };

    this.openLightboxOnImage = this.openLightboxOnImage.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
    this.displayPreviousImage = this.displayPreviousImage.bind(this);
    this.displayNextImage = this.displayNextImage.bind(this);
  }

  openLightboxOnImage(imageIndex) {
    this.setState({
      imageIndex : imageIndex,
      isOpen : true,
    });
  }

  closeLightbox() {
    this.setState({isOpen : false});
  }

  displayPreviousImage() {
    this.setState({imageIndex : (this.state.imageIndex - 1) % this.props.data.length});
  }

  displayNextImage() {
    this.setState({imageIndex : (this.state.imageIndex + 1) % this.props.data.length});
  }

  render() {
    let title = this.props.title ? <Title name={this.props.title}></Title> : null;
    let data = this.props.data;

    let images = data.map(
      (src, index) =>
        <Image
          index={index}
          onClick={this.openLightboxOnImage.bind(this)}
          src={src}>
        </Image>
    );

    return (
      <div>

        {title}

        <Grid
          data = {images}
          nCellsPerRow = {nImagesPerRowDesktop}
          nCellsPerRowMobile = {nImagesPerRowMobile}
          margin = {20}
        >
        </Grid>

        {this.state.isOpen && (
          <div style={{zIndex: 500000}}>
            <Lightbox
              mainSrc={data[this.state.imageIndex]}
              nextSrc={data[(this.state.imageIndex + 1) % data.length]}
              prevSrc={data[(this.state.imageIndex - 1) % data.length]}
              reactModalStyle={style}
              enableZoom={false}
              imagePadding={50}
              animationDisabled={true}
              onCloseRequest={() => this.closeLightbox()}
              onMovePrevRequest={() => this.displayPreviousImage()}
              onMoveNextRequest={() => this.displayNextImage()}
            />
          </div>
        )}
      </div>

    );
  }
}

export default {ImageGallery}



// WEBPACK FOOTER //
// ./src/components/ImageGallery/index.js